// import { Curve } from '../core/Curve.js';
// import { CatmullRom } from '../core/Interpolations.js';
// import { Vector2 } from '../../math/Vector2.js';


import * as THREE from 'three';

export function DoubleSideSplineCurve(xStep, yValues = []) {
    THREE.Curve.call(this);
    this.type = 'DoubleSideSplineCurve';
    this.xStep = xStep;
    this.yValues = yValues;
}

function indexRound(i, len) {
    if (i < 0) return i + len;
    if (i >= len) return i - len;
    return i;
}

function CatmullRom(t, p0, p1, p2, p3) {
	const v0 = (p2 - p0) * 0.5;
	const v1 = (p3 - p1) * 0.5;
	const t2 = t * t;
	const t3 = t * t2;
	return (2 * p1 - 2 * p2 + v0 + v1) * t3 + (- 3 * p1 + 3 * p2 - 2 * v0 - v1) * t2 + v0 * t + p1;
}

DoubleSideSplineCurve.prototype = Object.create(THREE.Curve.prototype);
DoubleSideSplineCurve.prototype.constructor = DoubleSideSplineCurve;

DoubleSideSplineCurve.prototype.isDoubleSideSplineCurve = true;


DoubleSideSplineCurve.prototype.getControlPoint = function(index, len) {
    let index2 = indexRound(index, len);
    return new THREE.Vector2(index * this.xStep, this.yValues[index2]);
};

DoubleSideSplineCurve.prototype.getPoint = function(t, optionalTarget = new THREE.Vector2()) {
    const len = this.yValues.length;
    const point = optionalTarget;
    const p = len * t;
    const intPoint = Math.floor(p);
    const weight = p - intPoint;
    const p0 = this.getControlPoint(intPoint - 1, len);
    const p1 = this.getControlPoint(intPoint, len);
    const p2 = this.getControlPoint(intPoint + 1, len);
    const p3 = this.getControlPoint(intPoint + 2, len);
    // console.log(intPoint, points, p0, p1, p2, p3);

    point.set(
        CatmullRom(weight, p0.x, p1.x, p2.x, p3.x),
        CatmullRom(weight, p0.y, p1.y, p2.y, p3.y)
    );

    return point;
};

DoubleSideSplineCurve.prototype.getPoints = function (divisions = 5) {
    const points = [];
    for (let d = 0; d <= divisions; d++) {
        points.push(this.getPoint(d / divisions));
    }
    return points;
},

DoubleSideSplineCurve.prototype.copy = function (source) {
    THREE.Curve.prototype.copy.call(this, source);
    this.xStep = source.xStep;
    this.yValues = [];
    for (let i = 0, l = source.points.length; i < l; i++) {
        this.yValues.push(source.yValues[i]);
    }
    return this;
};

DoubleSideSplineCurve.prototype.toJSON = function () {
    const data = Curve.prototype.toJSON.call(this);
    data.xStep = this.xStep;
    data.yValues = [];
    for (let i = 0, l = this.points.length; i < l; i++) {
        data.yValues.push(this.yValues[i]);
    }
    return data;
};

DoubleSideSplineCurve.prototype.fromJSON = function (json) {
    THREE.Curve.prototype.fromJSON.call(this, json);
    this.xStep = json.xStep;
    this.yValues = [];
    for (let i = 0, l = json.yValues.length; i < l; i++) {
        this.yValues.push(json.yValues[i]);
    }
    return this;
};




// WEBPACK FOOTER //
// ./src/views/penholder/scripts/DoubleSideSplineCurve.js